/**
 * Helper: alle Planzeilen eines Zeitraums laden (Backend-Seitengroesse max 100).
 * Fuer Raster/Dialoge, die den kompletten Tag bzw. die komplette Woche brauchen.
 */

import { api } from "@/services/api"
import type { ShiftPlanEntry, ShiftPlanListParams } from "@/types"

const PAGE_SIZE = 100
/** Sicherheitsdeckel: 20 Seiten = 2000 Zeilen (eine Woche liegt weit darunter) */
const MAX_PAGES = 20

export async function fetchAllShiftPlanEntries(
  params: Omit<ShiftPlanListParams, "page" | "size">
): Promise<ShiftPlanEntry[]> {
  const first = await api.planning.shiftPlan({ ...params, page: 1, size: PAGE_SIZE })
  const all = [...first.data]
  const pages = Math.min(Math.ceil(first.total / PAGE_SIZE), MAX_PAGES)
  for (let page = 2; page <= pages; page++) {
    const next = await api.planning.shiftPlan({ ...params, page, size: PAGE_SIZE })
    all.push(...next.data)
  }
  return all
}
